import React from 'react'

export const ClientAuthOutlet = React.lazy(() => import('./clientAuth-outlet'))
export const ClientLoginForm = React.lazy(() => import('./clientLogin-form'))
export const UserAuthOutlet = React.lazy(() => import('./userAuth-outlet'))
export const UserLoginForm = React.lazy(() => import('./userLogin-form'))
